import React, { useEffect } from 'react';

import { UiDialog as Dialog } from '@sunwisesoftware/sunwise-ui';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as contactFileActions from '../contactFile/actions';
import * as contactsActions from '../contacts/actions';

import * as actions from './actions';
import ContactForm from './components/ContactForm';
import * as selectors from './selectors';

const Container = ({
    closeModal,
    fetchContact,
    fetchUsers,
    handleClickBulkItems,
    isNewRecord,
    isOpenModal,
    onSuccessSave,
    redirect,
    reset,
    users,
}) => {
    const { t } = useTranslation();

    useEffect(() => {
        fetchUsers();
    }, []);

    useEffect(() => {
        return () => reset();
    }, []);

    return (
        <Dialog
            onClose={() => closeModal()}
            onExited={() => closeModal()}
            open={isOpenModal}
            size="md"
            title={`${isNewRecord ? t('Add') : t('Update')} ${t(
                'Contact',
            ).toLowerCase()}`}
        >
            <ContactForm
                closeModal={() => closeModal()}
                fetchContact={fetchContact}
                handleClickBulkItems={handleClickBulkItems}
                isNewRecord={isNewRecord}
                onSuccessSave={onSuccessSave}
                redirect={redirect}
                users={users}
            />
        </Dialog>
    );
};

Container.propTypes = {
    closeModal: PropTypes.func,
    fetchContact: PropTypes.func,
    fetchUsers: PropTypes.func,
    handleClickBulkItems: PropTypes.func,
    isNewRecord: PropTypes.bool,
    isOpenModal: PropTypes.bool,
    onSuccessSave: PropTypes.func,
    redirect: PropTypes.func,
    reset: PropTypes.func,
    users: PropTypes.array,
};

const mapStateToProps = createStructuredSelector({
    isNewRecord: selectors.getIsNewRecord,
    isOpenModal: selectors.getIsOpenModal,
    users: selectors.getUsersData,
});

const mapDispatchToProps = (dispatch) => ({
    closeModal: () => dispatch(actions.closeModal()),
    fetchUsers: () => dispatch(actions.fetchUsers()),
    fetchContact: (id) =>
        dispatch(contactFileActions.fetchContact(id, false, true)),
    handleClickBulkItems: (ids, value, callback) =>
        dispatch(contactsActions.prepareBulkItems(ids, value, {}, callback)),
    redirect: (link) => dispatch(push(link)),
    reset: () => dispatch(actions.reset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Container);
